
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner-directory",
      function () {
        return require("private-next-pages/partner-directory/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner-directory"])
      });
    }
  